import React from "react";

import TelField from "../../common/form/telField";
import AddressField from "../../common/form/addressField";
import InputField from "../../common/form/inputField";

const AddressInput = ({ formData, changeInput, changeTel, openPostCode }) => {
  const fields = [
    {
      itemKey: "nickname",
      label: "배송지명",
      type: "input",
      onChange: changeInput,
    },
    {
      itemKey: "recipientName",
      label: "받는 분",
      type: "input",
      onChange: changeInput,
    },
    {
      itemKey: "phone",
      label: "휴대전화",
      type: "tel",
      options: ["010"],
      onChange: changeTel,
    },
    {
      itemKey: "address",
      label: "주소",
      type: "address",
      adresValue: formData["address"],
      detailAdresValue: formData["detailAddress"],
      onChange: changeInput,
      buttonEvent: openPostCode,
    },
    {
      itemKey: "memo",
      label: "메모",
      type: "input",
      onChange: changeInput,
    },
  ];

  return (
    <ul>
      {fields.map((field) => {
        const { type, itemKey, ...rest } = field;

        switch (type) {
          case "input":
            return (
              <InputField key={itemKey} itemKey={itemKey} value={formData[itemKey]} {...rest} />
            );
          case "address":
            return (
              <AddressField
                key={itemKey}
                address={formData["address"]}
                detailAddress={formData["detailAddress"]}
                {...rest}
              />
            );
          case "tel":
            return <TelField key={itemKey} itemKey={itemKey} value={formData[itemKey]} {...rest} />;
          default:
            return null;
        }
      })}
    </ul>
  );
};

export default AddressInput;
